import { useEffect, useState } from 'react';
import { DealsService } from 'service/deals.service';
import { IDealType } from './types';

export const useFetchDealTypes = () => {
  const [dealTypes, setDealTypes] = useState<{ id: string; name: string; key: string }[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDealTypes = async () => {
      try {
        setLoading(true);
        const dealType = await DealsService.getDealTypes();

        if (dealType.data) {
          setDealTypes(
            dealType.data.map((type: IDealType) => {
              return {
                id: type.dealTypeId,
                name: type.dealTypeName,
                key: type.dealTypeKey,
              };
            }),
          );
        }
      } catch (error) {
        console.error('Failed to fetch dealTypes values:', error);
        setDealTypes([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDealTypes();
  }, []);

  return { dealTypes, loading };
};

export const useFetchStages = () => {
  const [stages, setStages] = useState<{ id: string; name: string }[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchStages = async () => {
      try {
        setLoading(true);
        const stages = await DealsService.getStages();

        if (stages.data) {
          setStages(
            stages.data.stages.map((stage: any) => {
              return {
                id: stage.stageName,
                name: stage.stageName,
              };
            }),
          );
        }
      } catch (error) {
        console.error('Failed to fetch stages values:', error);
        setStages([]);
      } finally {
        setLoading(false);
      }
    };

    fetchStages();
  }, []);

  return { stages, loading };
};
